import Shepherd from "shepherd.js";
import Sara from './images/SARA.png'

const tour = new Shepherd.Tour({
  tourName: 'Azatys-App-Tour',
  defaultStepOptions: {
    cancelIcon: {
      enabled: true,
    },
    arrow: false
  },
  exitOnEsc: true,
  useModalOverlay: true,
})

// STEPS TOURS

//Step 1
tour.addStep({
  id: 'step 1',
  title: 'Accès au compte',
  text: `<img src=${Sara} /><p>Cliquez sur l'icône en forme de bonhomme pour accéder au menu.</p>`,
  attachTo: {
    element: '.first-step',
    on: 'bottom'
  },
  buttons: [
    {
      action() {
        document.querySelector('.first-step').click()
        setTimeout(() => {
          document.querySelector('.first-step').click()
        }, 100)
        setTimeout(() => {
          document.querySelector('.first-step').click()

          return this.next()
        }, 200)
      },
      text: 'Suivant'
    }
  ]
})

//Step 2
tour.addStep({
  id: 'step 2',
  title: 'Accès aux sites',
  text: `<img src=${Sara} /><p>Cliquez sur l'onglet "Mes sites" pour gérer vos sites, ceux de vos concurrents et vos connexions.</p>`,
  attachTo: {
    element: '.redirect-step2',
    on: 'bottom'
  },
  when: {
    hide() {
      document.querySelector('.first-step').click()
    }
  },
  buttons: [
    {
      action() {
        return this.back()
      },
      text: 'Précédent',
      classes: 'shepherd-button-secondary'
    },
    {
      action() {
        document.querySelector('.first-step').click()
        document.querySelector('.redirect-step2').click()
        return this.next()
      },
      text: 'Suivant'
    }
  ]
})

//Step 3
tour.addStep({
  id: 'step 3',
  title: 'Renseignez mes sites',
  text: `<img src=${Sara} />
  <p>Retrouvez dans la rubrique « Mes noms de domaine » votre site web renseigné plus tôt. <br /> <br />
  Si votre forfait vous le permet, vous pourrez ajouter un site en cliquant sur « + ».</p>`,
  attachTo: {
    element: '.second-step',
    on: 'bottom'
  },
  buttons: [
    {
      action() {
        document.querySelector('.first-step').click()
        setTimeout(() => {
          document.querySelector('.first-step').click()
        }, 100)
        setTimeout(() => {
          document.querySelector('.first-step').click()

          setTimeout(() => {
            return this.back()
          }, 500)
        }, 200)
      },
      text: 'Précédent',
      classes: 'shepherd-button-secondary'
    },
    {
      action() {
        document.querySelector('#goTostep2-3').click()
        return this.next()
      },
      text: 'Suivant'
    }
  ]
})

//Step 4
tour.addStep({
  id: 'step 4',
  title: 'Renseignez mes sites concurrents',
  text: `<img src=${Sara} /><p>Ici, vous pouvez renseigner le site de vos concurrents afin de faire une évaluation de votre site par rapport à la concurrence. <br /> <br />
  Après avoir sélectionné votre site, cliquez sur « Ajouter un concurrent », entrez le nom et l'URL, puis enregistrez !</p>`,
  attachTo: {
    element: '.concurrent-step',
    on: 'bottom'
  },
  buttons: [
    {
      action() {
        window.history.back()
        setTimeout(() => {
          return this.back()
        }, 500)
      },
      text: 'Précédent',
      classes: 'shepherd-button-secondary'
    },
    {
      action() {
        document.querySelector('#goTostep3').click()
        return this.next()
      },
      text: 'Suivant'
    }
  ]
})

//Step 5
tour.addStep({
  id: 'step 5',
  title: 'Mes connexions',
  text: `<img src=${Sara} />
  <p>Prochainement, nos connexions se feront en automatique, cependant, dans un premier temps, vous devez nous donner accès manuellement à votre suivi analytics. <br /> <br /> 
  Cliquez sur le logo Analytics et découvrez notre tuto d'explication.</p>`,
  attachTo: {
    element: '.step4',
    on: 'right'
  },
  buttons: [
    {
      action() {
        window.history.back()
        setTimeout(() => {
          return this.back()
        }, 500)
      },
      text: 'Précédent',
      classes: 'shepherd-button-secondary'
    },
    {
      action() {
        // document.querySelector('#goTostep3-quiz').click()
        // setTimeout(() => {
        //   return this.next()
        // }, 2000)

        document.querySelector('.first-step').click()
        setTimeout(() => {
          document.querySelector('.first-step').click()
        }, 100)
        setTimeout(() => {
          document.querySelector('.first-step').click()

          return this.next()
        }, 200)
      },
      text: 'Suivant'
    }
  ]
})

//Step 5-6
// tour.addStep({
//   id: 'step 5-6',
//   title: "Mes informations d'activité",
//   text: `<img src=${Sara} />
//   <p>Découvrez notre questionnaire minimaliste qui va me permettre d'affiner les informations mes résultats sur votre identité digitale.</p>`,
//   attachTo: {
//     element: '.quiz-step',
//     on: 'right'
//   },
//   buttons: [
//     {
//       action() {
//         window.history.back()
//         setTimeout(() => {
//           return this.back()
//         }, 500)
//       },
//       text: 'Précédent',
//       classes: 'shepherd-button-secondary'
//     },
//     {
//       action() {
//         document.querySelector('.first-step').click()
//         setTimeout(() => {
//           document.querySelector('.first-step').click()
//         }, 100)
//         setTimeout(() => {
//           document.querySelector('.first-step').click()

//           return this.next()
//         }, 200)
//       },
//       text: 'Suivant'
//     }
//   ]
// })

//Step 6
tour.addStep({
  id: 'step 6',
  title: 'Accès au compte',
  text: `<img src=${Sara} /><p>Cliquez sur l’onglet « Mon compte » pour finaliser votre paramétrage.</p>`,
  attachTo: {
    element: '.redirect-step5',
    on: 'bottom'
  },
  when: {
    hide() {
      document.querySelector('.first-step').click()
    }
  },
  buttons:
    [
      {
        action() {
          // window.history.back()
          setTimeout(() => {
            return this.back()
          }, 500)
        },
        text: 'Précédent',
        classes: 'shepherd-button-secondary'
      },
      {
        action() {
          document.querySelector('.first-step').click()
          setTimeout(() => {
            document.querySelector('.redirect-step5').click()
            return this.next()
          }, 100)
        },
        text: 'Suivant'
      }
    ]
})

//Step 7
tour.addStep({
  id: 'step 7',
  title: 'Paramétrage de compte.',
  text: `<img src=${Sara} /><p>Complétez toutes les rubriques obligatoires de vos informations complémentaires.</p>`,
  attachTo: {
    element: '.step5',
    on: 'right'
  },
  buttons: [
    {
      action() {
        document.querySelector('.first-step').click()
        setTimeout(() => {
          document.querySelector('.first-step').click()
        }, 100)
        setTimeout(() => {
          document.querySelector('.first-step').click()

          setTimeout(() => {
            return this.back()
          }, 500)
        }, 200)
      },
      text: 'Précédent',
      classes: 'shepherd-button-secondary'
    },
    {
      action() {
        document.querySelector('#goTostep6').click()
        return this.next()
      },
      text: 'Suivant'
    }
  ]
})

//Step 8
tour.addStep({
  id: 'step 8',
  title: 'Inviter un utilisateur',
  text: `<img src=${Sara} /><p>Vous pouvez inviter un utilisateur en cliquant sur « inviter un utilisateur »</p>`,
  attachTo: {
    element: '#invite-step',
    on: 'top'
  },
  buttons: [
    {
      action() {
        window.history.back()
        setTimeout(() => {
          return this.back()
        }, 500)
      },
      text: 'Précédent',
      classes: 'shepherd-button-secondary'
    },
    {
      action() {
        document.querySelector('#invite-step-action').click()
        return this.next()
      },
      text: 'Suivant'
    }
  ]
})

//Step 9
tour.addStep({
  id: 'step 9',
  title: 'Inviter un utilisateur',
  text: `<img src=${Sara} /><p>Remplissez les informations de l’utilisateur que vous souhaitez inviter, puis validez. <br /> <br />
  Vérifiez bien que son adresse email est valide.</p>`,
  attachTo: {
    element: '.step7',
    on: 'right'
  },
  buttons: [
    {
      action() {
        window.history.back()
        setTimeout(() => {
          return this.back()
        }, 500)
      },
      text: 'Précédent',
      classes: 'shepherd-button-secondary'
    },
    {
      action() {

        return this.next()
      },
      text: 'Suivant'
    }
  ]
})

//Step 10
tour.addStep({
  id: 'step 10',
  title: 'Ma visibilité',
  text: `<img src=${Sara} /><p>Pour consulter vos tableaux de bord sur les indicateurs de performance de votre site.</p>`,
  attachTo: {
    element: '#visibilité',
    on: 'right'
  },
  when: {
    show() {
      document.querySelector('#visibilité').click()
    }
  },
  buttons: [
    {
      action() {
        window.history.back()
        setTimeout(() => {
          return this.back()
        }, 500)
      },
      text: 'Précédent',
      classes: 'shepherd-button-secondary'
    },
    {
      action() {
        return this.next()
      },
      text: 'Suivant'
    }
  ]
})

//Step 11
tour.addStep({
  id: 'step 11',
  title: 'Mes visites',
  text: `<img src=${Sara} /><p>Pour consulter vos tableaux de bord sur les indicateurs de visites de votre site.</p>`,
  attachTo: {
    element: '#visites',
    on: 'right'
  },
  when: {
    show() {
      document.querySelector('#visites').click()
    }
  },
  buttons: [
    {
      action() {
        window.history.back()
        setTimeout(() => {
          return this.back()
        }, 500)
      },
      text: 'Précédent',
      classes: 'shepherd-button-secondary'
    },
    {
      action() {
        document.querySelector('.first-step').click()
        setTimeout(() => {
          document.querySelector('.first-step').click()
        }, 100)
        setTimeout(() => {
          document.querySelector('.first-step').click()

          return this.next()
        }, 200)
      },
      text: "Suivant"
    }
  ]
})

//Step 12
tour.addStep({
  id: 'step 12',
  title: 'Guide Utilisateur',
  text: `<img src=${Sara} /><p>Vous pouvez à tout moment faire un tour guidé de notre plateforme en cliquant sur l'onglet « Tour Guide App ».</p>`,
  attachTo: {
    element: '.user-guide',
    on: 'bottom'
  },
  buttons: [
    {
      action() {
        return this.back()
      },
      text: 'Précédent',
      classes: 'shepherd-button-secondary'
    },
    {
      action() {
        return this.complete()
      },
      text: "C'est parti !"
    }
  ]
})

// LISTENERS TOURS
tour.on('cancel', () => {
  if (localStorage.getItem(Object.userEmail)) return
  document.querySelector('#visibilité').click()
})
tour.on('complete', () => {
  document.querySelector('#visibilité').click()
})

export { tour }